import store from '@/store/index'

const debug = process.env.NODE_ENV !== 'production';

const baseUrl = debug ? 'ws://localhost:8000/ws/': 'wss://chat.aleksey-start.ru/ws/'

export function initRoomWebSocket(roomUri) {
    let jwt = localStorage.getItem('TOKEN_STORAGE_KEY')
    let roomWebSocket = new WebSocket(`${baseUrl}chats/${roomUri}/?token=`+jwt);

    roomWebSocket.onclose = function(e) {
        console.error('Chat socket closed unexpectedly');
    };

    roomWebSocket.onmessage = function(event) {
        let message = JSON.parse(event.data)['message'];
        store.dispatch('chat/receiveMessage', {message, roomUri})
    };

    roomWebSocket.onerror = function(evt) {
        console.log(evt);
    }

    return roomWebSocket
}
